@if (batches$ | async; as batches) {
  @if (hasData) {
    <div class="widget-content">
      <h3>{{'Unscheduled batches' | translate}}</h3>
      <form [formGroup]="filtersForm" fxLayout="row wrap">
        <mat-form-field>
          <input formControlName="activityId" id="unscheduledActivitiesWidget-activityId" matInput [placeholder]="'Jobs Batch ID' | translate" type="text">
        </mat-form-field>
        <mat-form-field>
          <input formControlName="description" id="unscheduledActivitiesWidget-description" matInput [placeholder]="'Description' | translate" type="text">
        </mat-form-field>
        <mat-form-field>
          <input formControlName="store" id="unscheduledActivitiesWidget-store" matInput [placeholder]="'Store' | translate" type="text">
        </mat-form-field>
      </form>
      @if (batches.length > 0) {
        <p class="info">{{'Drag to the right to schedule' | translate }}</p>
      }
      <mat-selection-list role="list" cdkDropList class="widget_list" id="unscheduledActivitiesWidget-list">
        @for (batch of batches; track batch; let i = $index) {
          <mat-list-option role="listitem" class="fc-event" cdkDrag
            [attr.id]="batch.id" style="padding: 5px 0; height: auto" [ngClass]="{'highlighted': i % 2 === 0}"
            [attr.data-event]="getUnscheduledJobEvent(batch)">
            {{displayName(batch)}}
            <div *cdkDragPreview class="widget__item__preview">
              {{displayName(batch)}}
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  }
}
